import copyItemsService from '../../services/copyItemsService';
import { getApplyConversationActionContext, getRowIdsFromRowKeys, } from 'owa-mail-list-store';
import copyConversationService from 'owa-mail-store/lib/services/copyConversationService';
import { action } from 'satcheljs/lib/legacy';
/**
 * Copy the mail list rows to a destination folder
 * @param rowKeys of the rows to copy
 * @param originalTableView which contains the rows to move from
 * @param destinationFolderId id of the destination folder to move to
 * @param sourceFolderId the actual source folder that contains the rows
 */
export default action('copyMailListRows')(function copyMailListRows(rowKeys, originalTableView, destinationFolderId, sourceFolderId) {
    switch (originalTableView.tableQuery.listViewType) {
        case 0 /* Conversation */:
            var conversationActionContext = rowKeys.map(function (rowKey) {
                return getApplyConversationActionContext(rowKey, originalTableView.id);
            });
            copyConversationService(conversationActionContext, destinationFolderId, sourceFolderId)
                .catch();
            break;
        case 1 /* Message */:
            var rowIdStrings = getRowIdsFromRowKeys(rowKeys, originalTableView.id);
            copyItemsService(rowIdStrings, destinationFolderId)
                .catch();
            break;
    }
});
//# sourceMappingURL=copyMailListRows.js.map